/* ==========================================================================
   VSR Cart — Drawer (Offcanvas) + Warenkorb-Seite, AJAX über Section Rendering
   Progressive Enhancement: ohne JS posten die Formulare nativ nach /cart,
   das Header-Icon verlinkt nativ auf /cart.
   ========================================================================== */
(function () {
  'use strict';

  var DRAWER_SECTION = 'vsr-cart-drawer';
  var routes = window.routes || {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart'
  };

  var lastFocus = null;
  var stickyObserver = null;
  var errorTimer = null;
  var inFlight = false; /* verhindert Doppel-Adds und Stepper-Races während laufender Cart-Requests */

  function drawerEl() { return document.querySelector('[data-vsr-cart-drawer]'); }
  function drawerInner() { var d = drawerEl(); return d ? d.querySelector('[data-vsr-drawer-inner]') : null; }
  function cartRoot() { return document.querySelector('[data-vsr-cart-root]'); }

  /* ---------- Drawer öffnen / schließen ---------- */

  /* Direkter Klick-Listener auf dem Drawer-Root: schließt bei jedem Klick außerhalb
     des Panels (Overlay links daneben) — unabhängig von der Document-Delegation. */
  function ensureOutsideClose(d) {
    if (d.dataset.vsrCloseBound === '1') return;
    d.dataset.vsrCloseBound = '1';
    d.addEventListener('click', function (e) {
      if (!d.classList.contains('is-open')) return;
      var panel = d.querySelector('.vsr-cdrawer__panel');
      if (panel && !panel.contains(e.target)) closeDrawer();
    });
  }

  function openDrawer(showAdded, origin) {
    var d = drawerEl();
    if (!d) return;
    ensureOutsideClose(d);
    if (d.classList.contains('is-open')) {
      if (showAdded) flashAdded();
      return;
    }
    lastFocus = origin || document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vsr-cdrawer-lock');
    if (showAdded) flashAdded();
    window.setTimeout(function () {
      var target = d.querySelector('[data-vsr-drawer-close-btn]') || d.querySelector('.vsr-cdrawer__panel');
      if (target) target.focus();
    }, 80);
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open', 'is-added');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vsr-cdrawer-lock');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  /* Die Erfolgsmeldung bleibt bewusst stehen, bis der Drawer geschlossen wird
     (closeDrawer entfernt is-added) — ein Auto-Hide irritiert beim Lesen. */
  function flashAdded() {
    var d = drawerEl();
    if (!d) return;
    d.classList.add('is-added');
  }

  /* ---------- Section Rendering ---------- */

  function sectionsToRequest() {
    var list = [DRAWER_SECTION];
    var root = cartRoot();
    if (root && root.dataset.sectionId) list.push(root.dataset.sectionId);
    return list;
  }

  function captureCartUi(root) {
    var coupon = root.querySelector('[data-vsr-coupon-input]');
    var feedback = root.querySelector('[data-vsr-coupon-feedback]');
    var note = root.querySelector('[data-vsr-cart-note]');
    return {
      coupon: coupon ? coupon.value : '',
      feedbackText: feedback ? feedback.textContent : '',
      feedbackVisible: feedback ? feedback.classList.contains('is-visible') : false,
      feedbackError: feedback ? feedback.classList.contains('is-error') : false,
      note: note ? note.value : null,
      open: Array.prototype.map.call(root.querySelectorAll('details'), function (dt) { return dt.open; })
    };
  }

  function restoreCartUi(root, state) {
    if (!state) return;
    var coupon = root.querySelector('[data-vsr-coupon-input]');
    if (coupon && state.coupon) coupon.value = state.coupon;
    var feedback = root.querySelector('[data-vsr-coupon-feedback]');
    if (feedback && state.feedbackVisible) {
      feedback.textContent = state.feedbackText;
      feedback.classList.add('is-visible');
      if (state.feedbackError) feedback.classList.add('is-error');
    }
    var note = root.querySelector('[data-vsr-cart-note]');
    if (note && state.note !== null) note.value = state.note;
    Array.prototype.forEach.call(root.querySelectorAll('details'), function (dt, i) {
      if (typeof state.open[i] === 'boolean') dt.open = state.open[i];
    });
  }

  function applySections(sections) {
    if (!sections) return;
    var parser = new DOMParser();

    if (sections[DRAWER_SECTION]) {
      var freshDrawerDoc = parser.parseFromString(sections[DRAWER_SECTION], 'text/html');
      var freshInner = freshDrawerDoc.querySelector('[data-vsr-drawer-inner]');
      var currentInner = drawerInner();
      if (freshInner && currentInner) {
        var itemsEl = currentInner.querySelector('.vsr-cdrawer__items');
        var scrollPos = itemsEl ? itemsEl.scrollTop : 0;
        currentInner.innerHTML = freshInner.innerHTML;
        var freshItemsEl = currentInner.querySelector('.vsr-cdrawer__items');
        if (freshItemsEl) freshItemsEl.scrollTop = scrollPos;
      }
    }

    var root = cartRoot();
    if (root && root.dataset.sectionId && sections[root.dataset.sectionId]) {
      var freshPageDoc = parser.parseFromString(sections[root.dataset.sectionId], 'text/html');
      var freshRoot = freshPageDoc.querySelector('[data-vsr-cart-root]');
      if (freshRoot) {
        var uiState = captureCartUi(root);
        root.replaceWith(freshRoot);
        restoreCartUi(freshRoot, uiState);
        initCartSticky();
      }
    }

    /* Nach dem Inner-Swap hängt der Fokus sonst auf <body> — Falle wäre umgangen */
    var d = drawerEl();
    if (d && d.classList.contains('is-open') && !d.contains(document.activeElement)) {
      var closeBtn = d.querySelector('[data-vsr-drawer-close-btn]');
      if (closeBtn) closeBtn.focus();
    }

    syncHeaderCount();
    announce('Warenkorb aktualisiert');
  }

  function syncHeaderCount() {
    var src = document.querySelector('[data-vsr-cart-item-count]');
    if (!src) return;
    var count = parseInt(src.getAttribute('data-vsr-cart-item-count'), 10);
    if (isNaN(count)) return;
    document.querySelectorAll('.vsr-nav__cart').forEach(function (link) {
      var bubble = link.querySelector('.vsr-nav__cart-count');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'vsr-nav__cart-count';
          link.appendChild(bubble);
        }
        bubble.textContent = count;
      } else if (bubble) {
        bubble.remove();
      }
    });
  }

  function announce(text) {
    var region = document.querySelector('[data-vsr-cart-live]');
    if (region) region.textContent = text;
  }

  function setBusy(state) {
    var d = drawerEl();
    var panel = d ? d.querySelector('.vsr-cdrawer__panel') : null;
    if (panel) panel.classList.toggle('is-busy', state);
    var root = cartRoot();
    if (root) root.classList.toggle('is-busy', state);
  }

  function showError(message) {
    var d = drawerEl();
    var target = null;
    if (d && d.classList.contains('is-open')) target = d.querySelector('[data-vsr-cart-error]');
    if (!target) {
      var root = cartRoot();
      if (root) target = root.querySelector('[data-vsr-cart-error]');
    }
    if (!target) return;
    target.textContent = message || 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut.';
    target.classList.add('is-visible');
    if (errorTimer) window.clearTimeout(errorTimer);
    errorTimer = window.setTimeout(function () { target.classList.remove('is-visible'); }, 6000);
  }

  /* ---------- Cart-API ---------- */

  function changeLine(key, quantity) {
    if (inFlight) return;
    inFlight = true;
    setBusy(true);
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionsToRequest().join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (result) {
        if (!result.ok) {
          showError(result.json.description || result.json.message);
          return;
        }
        applySections(result.json.sections);
      })
      .catch(function () { showError(); })
      .finally(function () { inFlight = false; setBusy(false); });
  }

  function addVariant(variantId, quantity) {
    if (inFlight) return Promise.resolve();
    inFlight = true;
    setBusy(true);
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity || 1,
        sections: sectionsToRequest().join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (result) {
        if (!result.ok) {
          showError(result.json.description || result.json.message);
          return;
        }
        applySections(result.json.sections);
        if (!cartRoot()) openDrawer(true);
        else flashAdded();
      })
      .catch(function () { showError(); })
      .finally(function () { inFlight = false; setBusy(false); });
  }

  function addFromForm(form, submitter) {
    if (inFlight) return;
    inFlight = true;
    var origin = document.activeElement; /* vor dem Disable sichern — sonst landet lastFocus auf <body> */
    var formData = new FormData(form);
    formData.append('sections', sectionsToRequest().join(','));
    formData.append('sections_url', window.location.pathname);

    var button = submitter || form.querySelector('[type="submit"]');
    var restore = null;
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      var label = button.querySelector('span') || button;
      restore = { el: label, text: label.textContent };
      label.textContent = 'Wird hinzugefügt …';
    }

    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (result) {
        if (!result.ok) {
          /* Fehler sichtbar machen: Fehlerregion lebt im Drawer (auf der Cart-Seite im Root) */
          if (!cartRoot()) openDrawer(false, origin);
          showError(result.json.description || result.json.message);
          return;
        }
        applySections(result.json.sections);
        if (!cartRoot()) openDrawer(true, origin);
      })
      .catch(function () {
        if (!cartRoot()) openDrawer(false, origin);
        showError();
      })
      .finally(function () {
        inFlight = false;
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (restore) restore.el.textContent = restore.text;
        }
      });
  }

  function saveNote(note) {
    fetch(routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ note: note })
    }).catch(function () { /* nächster Checkout-Submit überträgt die Note ohnehin mit */ });
  }

  function applyDiscount(code, feedbackEl) {
    /* Der /discount/-Endpoint hinterlegt den Code als Cookie für den Checkout —
       die Gültigkeit prüft erst der Checkout selbst. */
    fetch('/discount/' + encodeURIComponent(code), { headers: { 'Accept': 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('discount request failed');
        if (feedbackEl) {
          feedbackEl.textContent = 'Code übernommen, er wird an der Kasse angewendet.';
          feedbackEl.classList.remove('is-error');
          feedbackEl.classList.add('is-visible');
        }
      })
      .catch(function () {
        if (feedbackEl) {
          feedbackEl.textContent = 'Code konnte nicht gespeichert werden. Sie können ihn auch an der Kasse eingeben.';
          feedbackEl.classList.add('is-error', 'is-visible');
        }
      });
  }

  /* ---------- Sticky-CTA auf der Warenkorb-Seite ---------- */

  function initCartSticky() {
    if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
    var root = cartRoot();
    if (!root) {
      document.body.classList.remove('vsr-has-cart-sticky');
      return;
    }
    var anchor = root.querySelector('[data-vsr-cart-cta-main]');
    var bar = root.querySelector('[data-vsr-cart-sticky]');
    if (!anchor || !bar) {
      document.body.classList.remove('vsr-has-cart-sticky');
      return;
    }
    if (typeof IntersectionObserver === 'undefined') return;
    stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('vsr-has-cart-sticky', show);
      });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
    stickyObserver.observe(anchor);
  }

  /* ---------- Events (Delegation, überlebt Section-Swaps) ---------- */

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-vsr-cart-open]');
    if (opener) {
      if (cartRoot()) return; /* auf der Warenkorb-Seite: normale Navigation zulassen */
      if (!drawerEl()) return; /* kein Drawer im DOM: Link nativ zu /cart folgen lassen */
      e.preventDefault();
      openDrawer(false);
      return;
    }

    if (e.target.closest('[data-vsr-drawer-close]') || e.target.closest('[data-vsr-drawer-close-btn]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var qtyBtn = e.target.closest('[data-vsr-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var current = parseInt(qtyBtn.getAttribute('data-quantity'), 10) || 1;
      var next = qtyBtn.getAttribute('data-vsr-qty') === 'plus' ? current + 1 : current - 1;
      if (next < 0) next = 0;
      /* Menge 0 = Position entfernen (Minus bei Menge 1) */
      if (next !== current) changeLine(qtyBtn.getAttribute('data-key'), next);
      return;
    }

    var removeBtn = e.target.closest('[data-vsr-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(removeBtn.getAttribute('data-vsr-line-remove'), 0);
      return;
    }

    var quickAdd = e.target.closest('[data-vsr-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      quickAdd.disabled = true;
      addVariant(quickAdd.getAttribute('data-vsr-quick-add'), 1).finally(function () {
        /* Bei Erfolg wurde der Button ohnehin per Section-Swap ersetzt —
           das Re-Enable greift nur im Fehlerfall. */
        quickAdd.disabled = false;
      });
      return;
    }

    var couponApply = e.target.closest('[data-vsr-coupon-apply]');
    if (couponApply) {
      e.preventDefault();
      var scope = couponApply.closest('[data-vsr-coupon]') || document;
      var input = scope.querySelector('[data-vsr-coupon-input]');
      var feedback = scope.querySelector('[data-vsr-coupon-feedback]');
      var code = input ? input.value.trim() : '';
      if (code) applyDiscount(code, feedback);
      return;
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || typeof form.action !== 'string') return;
    if (e.defaultPrevented) return; /* z. B. Dawn <product-form> mit eigenem AJAX — kein Doppel-Add */
    if (form.hasAttribute('data-vsr-no-ajax')) return;
    if (form.action.indexOf('/cart/add') === -1) return;
    if (!drawerEl() && !cartRoot()) return; /* ohne Drawer-UI: nativer POST als Fallback */
    e.preventDefault();
    if (inFlight) return; /* Doppeltap (z. B. mobile Sticky-CTA via requestSubmit) schluckt der Guard */
    addFromForm(form, e.submitter);
  });

  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-vsr-cart-note]');
    if (note) saveNote(note.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-vsr-coupon-input]')) {
      e.preventDefault();
      var scope = e.target.closest('[data-vsr-coupon]') || document;
      var applyBtn = scope.querySelector('[data-vsr-coupon-apply]');
      if (applyBtn) applyBtn.click();
      return;
    }

    var d = drawerEl();
    if (!d || !d.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }

    if (e.key === 'Tab') {
      /* Fokus-Falle innerhalb des Panels */
      var panel = d.querySelector('.vsr-cdrawer__panel');
      if (!panel) return;
      var focusables = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartSticky);
  } else {
    initCartSticky();
  }
})();
